module.exports = __webpack_public_path__ + "static/parto-agendado-f41102854ffd8f277ec7025b05cdd65c.jpg";